<template>
  <div class="join-form">
    <div class="join-form--left">
      <div class="join-form--left--benefits">
        <div v-if="data.stage == 'student'" class="join-form--left--top">
          <h2>Supporting Students</h2>
          <p>
            We provide critical support to help you through your medical journey
            by lobbying government for additional training placements, providing
            resources and information to help transition you to the next stage
            of your career, or by providing mentorship programs with Australia's
            leading experts.
          </p>
        </div>
        <div v-else class="join-form--left--top">
          <h2>Workplace Relations</h2>
          <p>
            We are here to help, no matter what career stage you are in.
            Supporting you to ensure your rights are protected.
          </p>
        </div>
        <div class="join-form--left--list">
          <ul v-if="data.stage == 'student'">
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-school"><path d="M14 22v-4a2 2 0 1 0-4 0v4"/><path d="m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2"/><path d="M18 5v17"/><path d="m4 6 8-4 8 4"/><path d="M6 5v17"/><circle cx="12" cy="9" r="2"/></svg>
              </span>
              <span class="text">
                <strong>Student membership</strong><br />Free membership for all
                medical students in Australia.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-messages-square"><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2z"/><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/></svg>
              </span>
              <span class="text">
                <strong>Mentorship programs</strong><br />Connect with senior
                doctors that will help you enhance your career.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ticket"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>
              </span>
              <span class="text">
                <strong>Networking events</strong><br />Build connections with
                other students and senior doctors.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gavel"><path d="m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>
              </span>
              <span class="text">
                <strong>Webinars and resources</strong><br />Range of resources
                to assist you with your transition to an internship.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </span>
              <span class="text">
                <strong>Coaching services and career solutions</strong
                ><br />Designed to support you across your entire career
                lifecycle.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>
              </span>
              <span class="text">
                <strong>Lobbying and advocacy</strong><br />We will fight for
                important issues that matter most to you.
              </span>
            </li>
          </ul>
          <ul v-else>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-plus"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M9 12h6"/><path d="M12 9v6"/></svg>
              </span>
              <span class="text">
                <strong>Public hospital matters</strong><br />Connections to
                help resolve matters quickly to avoid legal processes.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-speech"><path d="M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20"/><path d="M19.8 17.8a7.5 7.5 0 0 0 .003-10.603"/><path d="M17 15a3.5 3.5 0 0 0-.025-4.975"/></svg>
              </span>
              <span class="text">
                <strong>Negotiations and determinations</strong><br />Fighting
                for your rights through negotiations and grievance resolution.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-door-open"><path d="M13 4h3a2 2 0 0 1 2 2v14"/><path d="M2 20h3"/><path d="M13 20h9"/><path d="M10 12v.01"/><path d="M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z"/></svg>
              </span>
              <span class="text">
                <strong>Performance management</strong><br />Support to achieve
                outcomes in performance review meetings.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-triangle-alert"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
              </span>
              <span class="text">
                <strong>Bullying and harassment</strong><br />Navigating members
                through complains and dispute processes.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-scroll"><path d="M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4"/><path d="M19 17V5a2 2 0 0 0-2-2H4"/></svg>
              </span>
              <span class="text">
                <strong>Contract checking service</strong><br />Get your
                contract checked to ensure it is fair.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
              </span>
              <span class="text">
                <strong>Unfair dismissals and workplace investigations</strong
                ><br />Individual support and practice resources on employment
                law.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-hospital"><path d="M12 6v4"/><path d="M14 14h-4"/><path d="M14 18h-4"/><path d="M14 8h-4"/><path d="M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2"/><path d="M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18"/></svg>
              </span>
              <span class="text">
                <strong>Practice management support</strong><br />Tailored
                workplace relations and human resources support.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-plus"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/><path d="M9 10h6"/><path d="M12 7v6"/></svg>
              </span>
              <span class="text">
                <strong>Practice management resources</strong><br />Employee
                contract templates and workplace relations manual advice.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="join-form--right">
      <div class="join-form--step">
        <div class="step-legend">
          <h2 v-if="data.stage == 'student'">Education details</h2>
          <h2 v-else>Professional details</h2>
          <step-circles step="3" />
        </div>
        <div v-if="data.stage == 'student'" class="step-intro">
          Fill out your educational details so that we tailor our services to
          you.
        </div>
        <div v-else class="step-intro">
          Fill out your professional details so that we tailor our services to
          you.
        </div>
        <div class="step-form--scroll--wrapper">
          <div @scroll="checkTooltip" class="step-form step-form--scroll">
            <form
              @submit.prevent="next()"
              @keypress.enter.prevent
              class="nice-form"
              @input="markDirty"
            >
              <div v-if="data.stage == 'student'" class="step-form">
                <custom-field
                  label="University/School"
                  type="select"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.university"
                >
                  <template v-slot:options>
                    <option value="" disabled="" selected></option>
                    <option value="ANU">Australian National University</option>
                    <option value="BOND">Bond University</option>
                    <option value="CURTIN">Curtin University</option>
                    <option value="DEAKIN">Deakin University</option>
                    <option value="FLINDERS">Flinders University</option>
                    <option value="GRIFFITH">Griffith University</option>
                    <option value="JCU">James Cook University</option>
                    <option value="MONASH">Monash University</option>
                    <option value="MURDOCH">Murdoch University</option>
                    <option value="MQ">Macquarie University</option>
                    <option value="ADELAIDE">The University of Adelaide</option>
                    <option value="MELBOURNE">
                      The University of Melbourne
                    </option>
                    <option value="UNE">The University of New England</option>
                    <option value="UNSW">
                      The University of New South Wales
                    </option>
                    <option value="NEWCASTLE">
                      The University of Newcastle
                    </option>
                    <option value="UNDF">
                      The University of Notre Dame (Fremantle)
                    </option>
                    <option value="UNDS">
                      The University of Notre Dame (Sydney)
                    </option>
                    <option value="UQ">The University of Queensland</option>
                    <option value="USYD">The University of Sydney</option>
                    <option value="UTAS">The University of Tasmania</option>
                    <option value="UWA">
                      The University of Western Australia
                    </option>
                    <option value="WSYD">
                      The University of Western Sydney
                    </option>
                    <option value="WOLLON">The University of Wollongong</option>
                  </template>
                </custom-field>                
                <custom-field
                  label="Current year of study"
                  type="select"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.current_year"
                >
                  <template v-slot:options>
                    <option value="" disabled=""></option>
                    <option value="F1S1">First year</option>
                    <option value="F2S1">Second year</option>
                    <option value="F3S1">Third year</option>
                    <option value="F4S1">Fourth year</option>
                    <option value="F5S1">Fifth year</option>
                    <option value="F6S1">Sixth year</option>
                  </template>
                </custom-field>
                <custom-field
                  label="Commencement year"
                  type="number"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.start_year"
                />
                <custom-field
                  label="Expected graduate year"
                  type="number"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.end_year"
                />
                <custom-field
                  label="Post graduate Interest"
                  type="select"
                  :rules="{
                    reuqired: {},
                  }"
                  v-model="data.interest"
                >
                  <template v-slot:options>
                    <option value="" disabled=""></option>
                    <option
                      v-for="(label, key) in options.crafts"
                      :key="`i-${key}`"
                      :value="key"
                    >
                      {{ label }}
                    </option>
                  </template>
                </custom-field>
              </div>
              <div v-else class="step-form">
                <custom-field
                  v-show="memberships.length > 1 && data.promoteCode !== 'AMANSW25'"
                  label="Membership type"
                  type="select"
                  :rules="memberships.length > 1 ? { required: {} } : {}"
                  v-model="data.membership"
                >
                  <template v-slot:options>
                    <option value="" disabled="" selected=""></option>
                    <option
                      v-for="mo in memberships"
                      :value="mo.key"
                      :key="mo.key"
                    >
                      {{ mo.label }}
                    </option>
                  </template>
                </custom-field>
                <custom-field
                  v-if="data.state == 'SA' && data.membership == 'F1Y1'"
                  label="Coupon code"
                  maxlength="20"
                  v-model="data.offerdiscount"
                />
                <!---<div
                  v-if="data.state == 'SA' && data.membership == 'F2Y1' || data.membership == 'F3Y1' || data.membership == 'F4Y1' || data.membership == 'F5Y1'"
                  class="form-group ama-partner-rate"
                >
                  <input
                    type="checkbox"
                    class="d-none"
                    id="cpd-sub"
                    v-model="data.cpd_sub"
                    value="1"
                  />
                  <label for="cpd-sub">
                    <span v-if="data.cpd_sub">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                        ></path>
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                        ></path>
                      </svg>
                    </span>
                    <strong>I wish to pay for a CPD Subscription ($220)</strong>
                  </label>
                </div>-->
                <div
                  v-if="data.state == 'NSW' && data.stage == 'dit' && data.promoteCode !== 'AMANSW25'"
                  class="form-group ama-partner-rate"
                >
                  <input
                    type="checkbox"
                    class="d-none"
                    id="dit-intern"
                    v-model="data.dit_intern"
                    value="1"
                  />
                  <label for="dit-intern">
                    <span v-if="data.dit_intern">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                        ></path>
                      </svg>
                    </span>
                    <span v-else>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                        ></path>
                      </svg>
                    </span>
                    <strong>Are you a Part-time Doctor-in-training?</strong>
                  </label>
                </div>
                <custom-field
                  label="Primary speciality/practice"
                  type="select"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.speciality"
                >
                  <template v-slot:options>
                    <option
                      v-for="(s, key) in options.crafts"
                      :value="key"
                      :key="`crafts-${key}`"
                    >
                      {{ s }}
                    </option>
                  </template>
                </custom-field>
                <custom-field
                  v-if="data.state == 'NSW'"
                  label="Employed as"
                  type="select"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.emp_as"
                >
                  <template v-slot:options>
                    <option
                      v-for="(eo, key) in options.employAs"
                      :value="key"
                      :key="key"
                    >
                      {{ eo }}
                    </option>
                  </template>
                </custom-field>
                <custom-field
                  v-if="data.state == 'NSW'"
                  label="Hospital Employment"
                  type="select"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.hospitalEmp"
                >
                  <template v-slot:options>
                    <option
                      v-for="s in options.employHos"
                      :value="s.id"
                      :key="s.id"
                    >
                      {{ s.label }}
                    </option>
                  </template>
                </custom-field>
                <label class="top-label mt-1"
                  >What practice groups would you like to join?</label
                >
                <p class="text-center mt-2">
                  A practice group is a group of members with a particular or
                  distinctive professional or other interest. Doctors can be
                  members of more than one practice groups.
                </p>
                <div class="speciality-option--wrapper">
                  <div
                    v-for="(label, key) in options.practices"
                    :key="`so-${key}`"
                    @click.prevent="setPractices(key)"
                    class="speciality-option--item"
                    :class="{ active: data.practice_groups.includes(key) }"
                  >
                    <!--<i class="fal fa-check"></i>-->
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check fa-check"><path d="M20 6 9 17l-5-5"/></svg>
                    {{ label }}
                  </div>
                </div>

                <div v-if="data.state == 'SA'">
                  <label class="top-label mt-1"
                    >Communication preferences</label
                  >
                  <p class="text-center mt-2">
                    Choose your preferred communication methods.
                  </p>
                  <div
                    class="speciality-option--wrapper"
                    style="grid-template-columns: repeat(4, 1fr)"
                  >
                    <div
                      v-for="(sc, key) in options.saCommunication"
                      :key="`so-${key}`"
                      @click.prevent="setSACommunication(key)"
                      class="speciality-option--item"
                      :class="{ active: data.sa_communication.includes(key) }"
                    >
                      <!--<i class="fal fa-check"></i>-->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check fa-check"><path d="M20 6 9 17l-5-5"/></svg>
                      {{ sc }}
                    </div>
                  </div>

                  <label class="top-label mt-1">medicSA</label>
                  <p class="text-center mt-2">
                    How would you like to receive medicSA?
                  </p>
                  <div
                    class="speciality-option--wrapper"
                    style="grid-template-columns: repeat(2, 1fr)"
                  >
                    <div
                      v-for="(sm, key) in options.saMedicSA"
                      :key="`so-${key}`"
                      @click.prevent="setMedicSA(key)"
                      class="speciality-option--item"
                      :class="{ active: data.sa_medicSA.includes(key) }"
                    >
                      <!--<i class="fal fa-check"></i>-->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check fa-check"><path d="M20 6 9 17l-5-5"/></svg>
                      {{ sm }}
                    </div>
                  </div>
                </div>
                <div v-if="data.state == 'NSW'">
                  <label class="top-label mt-1"
                    >What groups you belong to?</label
                  >
                  <div class="speciality-option--wrapper speciality-three">
                    <div
                      v-for="(x, key) in options.profGroup"
                      :key="key"
                      @click.prevent="setGroups(key)"
                      class="speciality-option--item"
                      :class="{
                        active: data.professional_groups.includes(key),
                      }"
                    >
                      <!--<i class="fal fa-check"></i>-->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check fa-check"><path d="M20 6 9 17l-5-5"/></svg>
                      {{ x }}
                    </div>
                  </div>
                </div>
                <div v-if="data.state == 'QLD'">
                  <label class="top-label mt-1"
                    >Do you have an ongoing or pre-existing workplace
                    issue?</label
                  >
                  <p class="text-center mt-2">
                    Please be aware that if you have an ongoing or pre-existing
                    issue AMA Queensland reserves the right to determine the
                    level of support they can provide for you.
                  </p>
                  <div class="speciality-option--wrapper speciality-single">
                    <div
                      v-for="t in workplaceChoice"
                      :key="t"
                      @click.prevent="setWorkpace(t)"
                      class="speciality-option--item"
                      :class="{ active: data.workpaceSetting == t }"
                    >
                      <!--<i class="fal fa-check"></i>-->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check fa-check"><path d="M20 6 9 17l-5-5"/></svg>
                      {{ t }}
                    </div>
                  </div>
                </div>
                <div v-if="data.state == 'TAS' || data.state == 'NT'">
                  <label class="top-label mt-1">ASMOF</label>
                  <p class="text-center mt-2">
                    If you wish to opt in and become a member of the Australian
                    Salaried Medical Officers' Federation Tasmania (ASMOF TAS),
                    please tick this box.
                  </p>
                  <div class="speciality-option--wrapper speciality-single">
                    <div
                      v-for="m in asmofBox"
                      :key="m"
                      @click.prevent="setasmofBox(m)"
                      class="speciality-option--item"
                      :class="{ active: data.asmof == m }"
                    >
                      <!--<i class="fal fa-check"></i>-->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check fa-check"><path d="M20 6 9 17l-5-5"/></svg>
                      {{ m }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="step-footer">
                <button
                  type="button"
                  @click.prevent="$emit('update:step', 3)"
                  class="button button-outline-blue button-nm"
                >
                  Back
                </button>
                <button type="submit" class="button button-blue button-nm">
                  Next
                </button>
              </div>
            </form>
          </div>
          <div
            v-if="tooltip && data.stage !== 'student' && data.state == 'NSW'"
            class="scroll-tooltip"
          >
            <div class="scroll-tooltip--content">
              <ScrollIcon />
              <span>Scroll down for more details</span>
            </div>
            <div class="scroll-tooltip--arrow"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import stepCircles from "../stepCircles";
import customField from "../forms/customField";
import { ScrollIcon } from "../icons";
export default {
  name: "step-four",
  props: ["step", "form", "options"],
  components: {
    stepCircles,
    customField,
    ScrollIcon,
  },
  data() {
    return {
      data: {
        practice_groups: [],
        membership: "",
        professional_groups: [],
        sa_communication: [],
        sa_medicSA: [],
      },
      tooltip: true,
      workplaceChoice: ["Yes", "No"],
      asmofBox: ["Yes", "No"],
      isActive: false,
      formIsDirty: false,
    };
  },
  computed: {
    memberships() {
      const { stage, employment, state } = this.data;
      if (stage && stage != "student" && employment) {
        const memberships = this.options.memberships[state];
        return memberships[stage]["arrangement"][employment]["options"];
      }

      return [];
    },
  },
  methods: {
    setPractices(key) {
      if (this.data.practice_groups.includes(key)) {
        this.data.practice_groups = this.data.practice_groups.filter(
          (i) => i !== key
        );
      } else {
        this.data.practice_groups = [...this.data.practice_groups, key];
      }
    },
    setSACommunication(key) {
      if (this.data.sa_communication.includes(key)) {
        this.data.sa_communication = this.data.sa_communication.filter(
          (i) => i !== key
        );
      } else {
        this.data.sa_communication = [...this.data.sa_communication, key];
      }
    },
    setMedicSA(key) {
      if (this.data.sa_medicSA.includes(key)) {
        this.data.sa_medicSA = this.data.sa_medicSA.filter((i) => i !== key);
      } else {
        this.data.sa_medicSA = [...this.data.sa_medicSA, key];
      }
    },
    setGroups(id) {
      if (this.data.professional_groups.includes(id)) {
        this.data.professional_groups = this.data.professional_groups.filter(
          (i) => i !== id
        );
      } else {
        this.data.professional_groups = [...this.data.professional_groups, id];
      }
    },
    setWorkpace(e) {
      //console.log('workpaceIssue:', this.workpaceIssue)
      if (this.data.workpaceSetting != e) {
        this.data.workpaceSetting = e;
      }
    },
    setasmofBox(e) {
      //console.log('workpaceIssue:', this.workpaceIssue)
      if (this.data.asmof != e) {
        this.data.asmof = e;
      }
    },
    checkTooltip(e) {
      const container = e.target;
      const totalScroll = container.offsetHeight + container.scrollTop + 30;
      this.tooltip = totalScroll < container.scrollHeight;
    },
    markDirty() {
        this.formIsDirty = true;
    },
    next() {
      let failed = false;
      for (var i in this.$children) {
        const child = this.$children[i];
        if (child.onFocus) {
          const errors = child.onBlur();
          if (errors.length) {
            failed = true;
          }
        }
      }
      if (failed) return;

      /**if (this.data.cpd_sub) {
        switch (this.data.membership) {
          case "F2Y1":
            this.data.membership == "F2Y1 - 50% OFF";
            break;
          case "F3Y1":
            this.data.membership == "F3Y1 - 50% OFF";
            break;
          case "F4Y1":
            this.data.membership == "F4Y1 - 50% OFF";
            break;
          case "F5Y1":
            this.data.membership == "F5Y1 - 50% OFF";
            break;
          default:
            break;
        }
        this.data.payment = "A";
      }**/
      if(this.formIsDirty) {
          this.data['step'] = 4;
          window.apiTrack.post('', this.data).then(response => {
            if(response.data.success) {
              this.data.imis_id =  response.data.imis;
              //console.log("return value: ", response.data);
            }
          });
      }

      this.$emit("update:form", this.data);
      this.$emit("update:step", 5);
    },
  },
  mounted() {
    this.data = this.form;

    if (window.metadata.dityear == "1") {
      this.data.membership = "F1Y1";
    }
  },
};
</script>
